export default __webpack_public_path__ + "static/media/inquiry_main.2151ff66.png";